enum CompanySize {
  ONE_TO_FOUR = '1 - 4',
  FIVE_TO_TWENTY = '5 - 20',
  TWENTY_ONE_TO_FIFTY = '21 - 50',
  FIFTY_ONE_TO_ONE_FIFTY = '51 - 150',
  ONE_FIFTY_ONE_PLUS = '151+',
}

export default CompanySize;
